export enum EActionTypes {
  SetQP = 'page/setQueryParams',
  SetDealType = 'page/setDealType',
  ToggleStickyFooterVisible = 'page/toggleStickyFooterVisible',
  SetPageCta = 'page/setPageCta',
  SetPushSettingsOpened = 'page/setPushSettingsOpened',
  ClearIsFromOfferCard = 'page/clearIsFromOfferCard/',
  SetMinGeoId = 'page/setMinGeoId',
  SetPageType = 'page/setPageType',
}
